import { deckFor } from "./dims.js";
/**
 * legalCheck: width>102 over; enclosed height>interior over;
 * open freight+deck>162 over; length>636 over, >576 needs 53;
 * weight+tare>80000 over.
 */
export function legalCheck(input) {
    const flags = [];
    if (input.widthIn != null && input.widthIn > 102) {
        flags.push({
            code: "over_width",
            message: `Width ${input.widthIn} in exceeds 102 in`,
        });
    }
    const enclosed = input.enclosed === true ||
        (input.trailerHint != null &&
            /\b(van|reefer|enclosed|dry\s*van)\b/i.test(input.trailerHint));
    if (input.heightIn != null) {
        if (enclosed) {
            const interior = input.interiorHeightIn ??
                (input.trailerHint ? deckFor(input.trailerHint) : 110);
            if (input.heightIn > interior) {
                flags.push({
                    code: "over_height",
                    message: `Height ${input.heightIn} in exceeds interior ${interior} in`,
                });
            }
        }
        else {
            const deck = input.trailerHint ? deckFor(input.trailerHint) : 60;
            if (input.heightIn + deck > 162) {
                flags.push({
                    code: "over_height",
                    message: `Freight+deck ${input.heightIn + deck} in exceeds 162 in`,
                });
            }
        }
    }
    if (input.lengthIn != null) {
        if (input.lengthIn > 636) {
            flags.push({
                code: "over_length",
                message: `Length ${input.lengthIn} in exceeds 636 in (53 ft)`,
            });
        }
        else if (input.lengthIn > 576) {
            flags.push({
                code: "needs_53",
                message: `Length ${input.lengthIn} in needs a 53 ft trailer`,
            });
        }
    }
    if (input.weightLb != null && input.weightLb + input.tareLb > 80000) {
        flags.push({
            code: "over_weight",
            message: `Gross ${input.weightLb + input.tareLb} lb exceeds 80000 lb`,
        });
    }
    return { ok: flags.length === 0, flags };
}
//# sourceMappingURL=legal.js.map